import { render, staticRenderFns } from "./ArtAppreciation.vue?vue&type=template&id=7fbb0084&scoped=true"
import script from "./ArtAppreciation.vue?vue&type=script&lang=js"
export * from "./ArtAppreciation.vue?vue&type=script&lang=js"
import style0 from "./ArtAppreciation.vue?vue&type=style&index=0&id=7fbb0084&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbb0084",
  null
  
)

export default component.exports